import smartHomeIndex from '@/views/smartLife/smartHome/index.vue'

export default {
  path: '/smartLife',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    {
      path: 'smartHome/index',
      name: 'smartHomeIndex',
      component: smartHomeIndex
    }

  ]
}
